import{r}from"../../_virtual/index2.js";import o from"./lib/react-input-mask.production.min.js";import t from"./lib/react-input-mask.development.js";if(process.env.NODE_ENV==="production"){r.exports=o}else{r.exports=t}var e=r.exports;export{e as default};
//# sourceMappingURL=index.js.map
